import serviceCalls from "../services/serviceCalls";
import { toastr } from 'react-redux-toastr';
import { handleUnAuthorized } from "../utils/index";

export const initiateRegistration = async (data) => {
	try {
		let result = await serviceCalls.post('/api/register', data, false);
		if (result?.status == 422 || result?.status == "error" || result?.data?.status == "error") {
			const errorMsg = (result?.data && Object.keys(result?.data).length) ? Object.values(result?.data)[0][0] : (result?.error || result?.data?.error || result?.data[0] || "User Registration Fail");
			toastr.error("Registration", errorMsg);
			throw new Error(result?.data?.error);
		} else if (result?.status == "success") {
			return result;
		} else {
			return {}
		}

	} catch (e) {
		return {};
	}
}

export const verifyEmail = async (data) => {
	try {
		let result = await serviceCalls.post('/api/verify_email', data, true);
		if (result?.status == 422 || result?.status == "error" || result?.data?.status == "error") {
			toastr.error("Verification", result?.error || result?.data?.error || "verify_email fail");
			throw new Error(result?.data?.error);
		} else if (result?.status == "success") {
			return result;
		} else {
			return {};
		}
	} catch (e) {
		return {};
	}
}

export const resendVerifyEmail = async (data) => {
	try {
		let result = await serviceCalls.post('/api/resend_verification_email', data, true);
		if (result?.status == 422 || result?.status == "error" || result?.data?.status == "error") {
			toastr.error("Email Verification", result?.error || result?.data?.error || "Email verification fail");
			throw new Error(result?.data?.error);
		} else if (result?.status == "success") {
			return result;
		} else {
			return {};
		}
	} catch (e) {
		return {};
	}
}

// run on the server side...
export const getAllPrograms = async (data) => {
	try {
		let result = await serviceCalls.get('/api/all_programs', data, false);
		if (result?.status == 422 || result?.status == "error" || result?.data?.status == "error") {
			throw new Error(result?.data?.error);
		} else {
			return result;
		}
	} catch (e) {
		return [];
	}
}
// run on the server side...
export const getAllHeardSources = async (data) => {
	try {
		let result = await serviceCalls.get('/api/heard_source', data, false);
		if (result?.status == 422 || result?.status == "error" || result?.data?.status == "error") {
			throw new Error(result?.data?.error);
		} else {
			return result;
		}
	} catch (e) {
		return [];
	}
}

export const getAllTopics = async (data) => {
	try {
		let result = await serviceCalls.get('/api/all_topics', data, true);
		if (result?.status == 401) {
			handleUnAuthorized(result);
		} else if (result?.status == 422 || result?.status == "error" || result?.data?.status == "error") {
			toastr.error("Get All Topics", "Someting went wrong.");
			result = [];
		}
		return result;
	} catch (e) {
		return [];
	}
}

export const initiateNextStep = async (data, message) => {
	try {
		let result = await serviceCalls.post('/api/update_user', data, true);
		// result = handleUnAuthorized(result);
		if (result?.status == 422 || result?.status == "error" || result?.data?.status == "error") {
			toastr.error(message, "User data not updated");
			result = {};
		}
		return result;
	} catch (e) {
		return {};
	}
}

export const updateUser = async (data) => {
	let result = await serviceCalls.post('/api/update_user_profile_info', data, true);
	// result = handleUnAuthorized(result);
	if (result?.status == 422 || result?.status == "error" || result?.data?.status == "error") {
		toastr.error("Sorry!", "User data not updated");
		result = {};
	}
	return result;
}

export const handleWelcomeTour = async (data) => {
	let result = await serviceCalls.post('/api/close_new_user_popup', data, true);
	if (result && result.data) {
		result = {};
	}
	return result;
}


